// Carousel for the collection-driven "Product recommendations" section
// (same behaviour as the PDP recommendations swiper).
(function () {
  function initRecSwipers() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.js-rec-collection-swiper').forEach((elem) => {
      if (elem.dataset.swiperInit) return;
      elem.dataset.swiperInit = 'true';
      const mobileLayout = elem.dataset.mobileLayout || 1;
      new Swiper(elem, {
        slidesPerView: mobileLayout,
        slidesPerGroup: 1,
        spaceBetween: 8,
        speed: 1000,
        navigation: {
          nextEl: elem.querySelector('.product-recommendations__slider-nav .swiper-button-next'),
          prevEl: elem.querySelector('.product-recommendations__slider-nav .swiper-button-prev'),
        },
        breakpoints: {
          576: { slidesPerView: 2, slidesPerGroup: 2 },
          750: { slidesPerView: 3, slidesPerGroup: 3 },
          1200: { slidesPerView: 4, slidesPerGroup: 4 },
        },
      });
    });
  }

  initRecSwipers();
  document.addEventListener('shopify:section:load', initRecSwipers);
})();
